import { render, staticRenderFns } from "./member-dialog.vue?vue&type=template&id=7bb1bf64&scoped=true&"
import script from "./member-dialog.vue?vue&type=script&lang=js&"
export * from "./member-dialog.vue?vue&type=script&lang=js&"
import style0 from "./member-dialog.vue?vue&type=style&index=0&id=7bb1bf64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1bf64",
  null
  
)

export default component.exports